import { Container, Group, Text, Stack, Box, Anchor, Divider, useMantineTheme, SimpleGrid } from '@mantine/core';
import { IconMail, IconPhone, IconMapPin, IconBrandFacebook } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

export function Footer() {
  const theme = useMantineTheme();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      style={{
        background: `linear-gradient(135deg, ${theme.colors.gold[0]} 0%, ${theme.colors.blue[0]} 100%)`,
        borderTop: `1px solid ${theme.colors.gold[2]}`,
        marginTop: 'auto'
      }}
    >
      <Container size="lg" py="xl">
        <Stack gap="lg">
          {/* Main Footer Content */}
          <SimpleGrid cols={{ base: 1, sm: 3 }} spacing="xl">
            {/* Brand Section */}
            <Box>
              <Text fw={700} size="xl" c={theme.colors.gold[7]} mb="sm">
                Lykke Terapien
              </Text>
              <Text size="sm" c="dimmed" lh={1.6} mb="md">
                Akupunkturklinik i Horsens med fokus på din individuelle vej til balance og velvære.
              </Text>
              <Group gap="sm">
                <Anchor
                  href="https://www.facebook.com/profile.php?id=61578172092566"
                  target="_blank"
                  rel="noopener noreferrer"
                  c={theme.colors.gold[6]}
                  style={{ ':hover': { color: theme.colors.gold[7] } }}
                >
                  <IconBrandFacebook size={20} />
                </Anchor>
              </Group>
            </Box>

            {/* Navigation Links */}
            <Box>
              <Text fw={600} size="md" mb="sm" c={theme.colors.dark[7]}>
                Navigation
              </Text>
              <Stack gap="xs">
                <Anchor component={Link} to="/" size="sm" c="dimmed" td="none">
                  Forside
                </Anchor>
                <Anchor component={Link} to="/om-mig" size="sm" c="dimmed" td="none">
                  Om mig
                </Anchor>
                <Anchor component={Link} to="/behandlinger" size="sm" c="dimmed" td="none">
                  Behandlinger
                </Anchor>
                <Anchor component={Link} to="/kontakt" size="sm" c="dimmed" td="none">
                  Kontakt
                </Anchor>
                <Anchor
                  href="https://lykke-terapien.planway.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  size="sm"
                  c="dimmed"
                  td="none"
                >
                  Book tid
                </Anchor>
              </Stack>
            </Box>

            {/* Contact Information */}
            <Box>
              <Text fw={600} size="md" mb="sm" c={theme.colors.dark[7]}>
                Kontakt
              </Text>
              <Stack gap="xs">
                <Group gap="xs">
                  <IconPhone size={16} color={theme.colors.gold[6]} />
                  <Anchor href="tel:+4560803735" size="sm" c="dimmed" td="none">
                    +45 60 80 37 35
                  </Anchor>
                </Group>
                <Group gap="xs">
                  <IconMail size={16} color={theme.colors.gold[6]} />
                  <Anchor href="mailto:lykketerapien@gmail.com" size="sm" c="dimmed" td="none">
                    lykketerapien@gmail.com
                  </Anchor>
                </Group>
                <Group gap="xs" align="flex-start">
                  <IconMapPin size={16} color={theme.colors.gold[6]} style={{ marginTop: 2 }} />
                  <Anchor 
                    href="https://maps.google.com?q=Stampemøllevej+21,+8700+Horsens,+Danmark"
                    target="_blank"
                    rel="noopener noreferrer"
                    size="sm" 
                    c="dimmed" 
                    td="none"
                  >
                    <Box>
                      <Text size="sm" c="dimmed">
                        Stampemøllevej 21
                      </Text>
                      <Text size="sm" c="dimmed">
                        8700 Horsens, Danmark
                      </Text>
                    </Box>
                  </Anchor>
                </Group>
              </Stack>
            </Box>
          </SimpleGrid>

          <Divider color={theme.colors.gold[2]} />

          {/* Bottom Footer */}
          <Group justify="center" align="center">
            <Text size="xs" c="dimmed" ta="center">
              © {currentYear} Lykke Terapien. Alle rettigheder forbeholdes.
            </Text>
          </Group>
        </Stack>
      </Container>

      <style>{`
        /* Hover effects */
        .mantine-Anchor-root:hover {
          transform: translateY(-1px);
          transition: all 0.2s ease;
        }
      `}</style>
    </Box>
  );
}
